// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__fOQz6","sectionTitle":"Contact_sectionTitle__RYeHB","contactCointaner":"Contact_contactCointaner__7DgNm"};